'use client'

import React, { memo, useEffect, useRef } from "react";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import useOnScreen from "@/helpers/Onscreen";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import styles from "./HeroSectionHomeNew.module.scss";
import cn from "clsx";
import { scheduleAfterPaint } from "@/helpers/scheduleAfterPaint";
import { useCommonData } from "@/context/CommonDataContext";

const CTARow: React.FC<{ associatedPrograms: any }> = ({ associatedPrograms }) => {
  const modalDispatch = useModalDispatch();
  const ref = useRef(null);
  const onScreen = useOnScreen(ref);
  const { device } = useCommonData();
  const isDweb = device === "desktop";

  useEffect(() => {
    const callIcon = document.getElementById("call-icon");
    const whatsapp = document.getElementById("whatts-app-journey");
    const chatButtonIcon = document.getElementById("chat-launcher-btn");
    const enrollNowRef = document.getElementById("enroll-now-cta");

    // DWeb: sticky side-tray icons (Call / WhatsApp / CMS icons) stay visible
    // over the hero. getElementById only reached Call + the first tray link,
    // so CMS-added icons never hid — keep them all consistent. MWeb unchanged.
    if (callIcon && !isDweb) {
      callIcon.style.display = onScreen ? "none" : "block";
    }
    if (whatsapp && !isDweb) {
      whatsapp.style.display = onScreen ? "none" : "block";
    }
    if (chatButtonIcon) {
      chatButtonIcon.style.display = onScreen ? "none" : "block";
    }
    if (enrollNowRef) {
      enrollNowRef.style.display = onScreen ? "none" : "block";
    }

  }, [onScreen, isDweb]);

  const handleBtnClicked = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalV2,
        modalData: {
          heading: "Get career guidance designed for your goals",
          submitBtnText: "Book a Free Session",
          associatedPrograms,
          isLandingPage: true,
        },
      },
    });

    // Same events/payloads — after modal open paints (keeps open-click INP low).
    scheduleAfterPaint(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Get Free Counselling",
        section_name: "hero_banner",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });

      updateStateSession({
        parentSection: "hero_banner",
        leadStartingCta: "Get Free Counselling",
      });

      window?.webengage?.track("Get Free Counselling Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
        "Section Name": "Hero Banner",
      });
    });
  };
  
  const btnClicked = () => {
     modalDispatch({
          type: IModalActions.OpenModal,
          data: {
            modalType: ModalTypes.ConnectModalMobileNumber,
            modalData: {
              heading: "Join India's No. 1 Online University",
              submitBtnText: "Submit",
              isLandingPage: true,
              associatedPrograms,
              rfiCase: "REDIRECT_APPLICATION_JOURNEY"
            },
          },
        });
    scheduleAfterPaint(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Get Free Counselling",
        section_name: "hero_banner",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });

      updateStateSession({
        parentSection: "hero_banner",
        leadStartingCta: "Get Free Counselling",
      });

      window?.webengage?.track("Get Free Counselling Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
        "Section Name": "Hero Banner",
      });
    });
  };


  const handleGTEvents = () => {
    // Keep sync — this is an <a href> navigation; deferred track can drop on unload.
    pushToDataLayer({
      event: "view_all_cta_click",
      cta_text: "Explore All Programs",
      section_name: "hero_banner",
      page_type: getGlobalStateValue("pageType"),
      page_url: window.location.href,
    });

    window?.webengage?.track("All Programs Clicked", {
      "Page Type": getGlobalStateValue("pageType"),
      "Section Name": "Program Discovery",
    });
  };

  return (
    <div className={styles.ctaRow}>
      <button className={cn(styles.ctaPrimary,styles.hidden)} onClick={btnClicked} id="vwo_get_free_couselling">
        Get Free Counselling
      </button>
      <button ref={ref} className={styles.ctaPrimary} onClick={handleBtnClicked} id="btn_header_get_free_couselling">
        Get Free Counselling <span className={styles.arrowUTF8}>&#8594;</span>
      </button>
      <a href={"/programs"} onClick={handleGTEvents} className={styles.ctaSecondary}>
        Explore All Programs{" "}<span className={styles.arrowUTF8}>&#8594;</span>
      </a>
    </div>
  );
};

export default memo(CTARow);
